import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { database } from 'firebase';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { AuthService } from '../../core/auth.service';
import { ServiceBase } from '../../shared/base/service-base';
import { UserService } from '../../users/shared/user.service';

import { Lecture } from './lecture';
import { LectureUserService } from './lecture-user.service';

@Injectable()
export class LectureService extends ServiceBase<Lecture> {
  static path = '/lectures';

  visibleLectures$: Observable<Lecture[]>;

  private filter$: ReplaySubject<any> = new ReplaySubject(1);
  private filteredLectures$: FirebaseListObservable<Lecture[]>;

  constructor(db: AngularFireDatabase, private auth: AuthService,
    private userService: UserService,
    private lectureUserService: LectureUserService) {
    super(db, LectureService.path);

    this.filteredLectures$ = db.list(LectureService.path, {query: {
      orderByChild: 'billing',
      equalTo: this.filter$
    }}).map(items => items.sort((a, b) => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })) as FirebaseListObservable<Lecture[]>;

    this.visibleLectures$ = this.filter$
      .switchMap(filter => {
        const visibleLectures$ = filter === null ? this.list : this.filteredLectures$;
        return this.userService.attachField(visibleLectures$, 'owner', 'ownerObservable');
      }).map(items => items.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      })) as Observable<Lecture[]>;
  }

  filterBilling(filter: string): void {
    switch (filter) {
      case 'false':
        this.filter$.next(false);
        break;

      case 'true':
        this.filter$.next(true);
        break;

      default:
        this.filter$.next(null);
        break;
    }
  }

  push(value: Lecture) {
    return super.push(Object.assign(new Lecture(), {
      owner: this.auth.auth.uid
    }, value));
  }

  async create(value: Lecture) {
    const lecture: database.ThenableReference = await this.push(value);
    await this.addUser(lecture);
    return lecture;
  }

  private addUser({ key }) {
    return this.lectureUserService.readUser({ $key: key }).set({ state: true });
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture.service.ts